<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-start display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! Parece estar perdido.</h4>
          <p class="text-muted">A página que procura não foi encontrada.</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-2">
        <br />
        <button class="btn btn-success" type="button" [routerLink]="['/home']"
          routerLinkActive="router-link-active">Voltar ao Início</button>
      </div>
    </div>
  </div>
</div>
